import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageDocuments } from "@components/modules/clients/documents/PageDocuments";
import { NavigationClient } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Documents`}
    navigation={<NavigationClient id={id} variant="panel" />}
  >
    <PageDocuments />
  </MainLayout>
);
const RouteComponent = withId(Page);

export const Route = createFileRoute("/clients/documents")({
  component: RouteComponent,
});
